import { __ } from 'i18n';

export const STATUSES = {
   'dnd': __('This contact is busy'),
   'online': __('This contact is online'),
   'offline': __('This contact is offline'),
   'unavailable': __('This contact is unavailable'),
   'xa': __('This contact is away for an extended period'),
   'away': __('This contact is away')
};
